import React from "react";
import {
  Dialog as MUIDialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * 入力用ダイアログコンポーネント
 * @param {string} title タイトル
 * @param {string} subtitle サブタイトル
 * @param {boolean} open 表示/非表示フラグ
 * @param {Function} onClose ダイアログを閉じた際の処理
 * @param {Node} children 子要素
 * @param {Node} actions ダイアログ下部のボタン
 * @param {string} maxWidth ダイアログ幅
 * @param {boolean} fullScreen 全画面かどうか
 * @class Dialog
 */
export default function InputDialog({
  title,
  subtitle,
  open,
  onClose,
  children,
  actions,
  type = "",
  fullScreen = false,
}) {
  return (
    <MUIDialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={fullScreen}
      className={`input-dialog ${type}`}
    >
      <div className="modal-head">
        <div className="modal-title">
          <h3 id="yieldKeypadTitle">{title}</h3>
          <p>{subtitle}</p>
        </div>
        <IconButton onClick={onClose} className="close-button" size="small">
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent>{children}</DialogContent>
      <DialogActions>{actions}</DialogActions>
    </MUIDialog>
  );
}
